__turbopack_context__.v({
  "button": "m-column-teaser-item-module__P52ODq__button",
  "container": "m-column-teaser-item-module__P52ODq__container",
  "headline": "m-column-teaser-item-module__P52ODq__headline",
  "icon": "m-column-teaser-item-module__P52ODq__icon",
  "text": "m-column-teaser-item-module__P52ODq__text",
});
